import React, { useState } from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify"; // make sure this is imported and set up
import "./SearchAutoComplete.css";

export default function SearchAutocomplete({ locationDataCallBack }) {
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const apiAddress = process.env.REACT_APP_SECRET;

  const handleInputChange = async (event, newInputValue) => {
    setInputValue(newInputValue);

    if (newInputValue.length < 2) {
      setOptions([]);
      return;
    }

    setLoading(true);
    try {
      setOptions([]);
      const url = `${apiAddress}/api/Location/GetLocationBySearchTerm?searchTerm=${newInputValue}`;
      const response = await axios.get(url);
      setOptions(response.data);
    } catch (error) {
      console.error("Error fetching autocomplete data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event, newValue) => {
    setSelectedOption(newValue);
    if (newValue) {
      locationDataCallBack(newValue);
    }
  };

  const handleGetLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          const url = `${apiAddress}/api/Location?latitude=${latitude}&longitude=${longitude}`;

          try {
            const response = await axios.get(url);
            const location = response.data;

            if (location) {
              // Add to options if not already present
              const updatedOptions = [
                location,
                ...options.filter((opt) => opt.id !== location.id),
              ];
              setOptions(updatedOptions);
              setSelectedOption(location);
              setInputValue(location.name || "");

              locationDataCallBack(location);

              toast.success("Location retrieved successfully", {
                theme: "colored",
              });
            } else {
              toast.error("Unable to retrieve location", { theme: "colored" });
            }
          } catch (error) {
            console.error("Error fetching location:", error);
            toast.error("Error fetching location", { theme: "colored" });
          }
        },
        (error) => {
          console.error("Geolocation error:", error);
          alert("Unable to retrieve location.");
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  return (
    <div className="row">
      <div className="col-8">
        <div className="form-group">
          <Autocomplete
            freeSolo
            filterOptions={(x) => x}
            options={options}
            loading={loading}
            inputValue={inputValue}
            onInputChange={handleInputChange}
            onChange={handleChange}
            value={selectedOption}
            getOptionLabel={(option) => option?.cityName || ""}
            className="location-autocomplete"
            renderInput={(params) => (
              <TextField
                {...params}
                label="Location"
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading && (
                        <CircularProgress color="inherit" size={20} />
                      )}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    height: 50,
                    fontSize: "16px", // optional to fit smaller height
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: "16px",
                  },
                }}
              />
            )}
          />
        </div>
      </div>
      <div className="col-4">
        <button
          type="button"
          className="btn btn-success"
          onClick={handleGetLocation}
        >
          Get location
        </button>
      </div>
    </div>
  );
}
